import React, {useCallback, useContext, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {AppContext} from 'adapter';
import Alert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';
import {Avatar, Button, Typography} from "@material-ui/core";
import {Link as RouterLink} from 'react-router-dom';
import AuthenticationDialog from "components/AuthenticationDialog";
import moment from "moment/moment";

const useStyles = makeStyles(theme => ({
    avatar: {
        width: 60,
        height: 60
    },
    user: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(1),
    },
    line: {
        height: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    name: {
        marginLeft: theme.spacing(1),
    },
    setting: {
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
    }
}));

const Profile = () => {
    const {user, setUser, notice, systemInfo, api} = useContext(AppContext);
    const classes = useStyles();
    const [openAuthDialog, setOpenAuthDialog] = useState(false);
    const hasAuthentication = !!(user['authenticationThirdPartyId']);

    const reloadProfile = useCallback(() => {
        api.getUser().then((res) => {
            if (res.status === 0) {
                api.setStore(res.data);
                setUser({
                    ...res.data,
                    time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                });
            }
        })
    }, [api, setUser])

    return (
        <div>
            <div className={classes.user}>
                <Avatar
                    className={classes.purple}
                    component={RouterLink}
                    to="/"
                >
                    {user.userName ? user.userName[0] : ''}
                </Avatar>
                <Typography
                    className={classes.name}
                    variant="h3"
                >
                    {user.userName}
                </Typography>
            </div>
            <div className={classes.user}>
                <Typography variant="h5">余额: {user.balance}</Typography>
            </div>
            {
                systemInfo.supportCertification ? (
                    hasAuthentication ? (
                        <div className={classes.user}>
                            <Typography
                                color={"textSecondary"}
                                variant="h6">已实名: {(user.authenticationType || '').indexOf('enterprise') >= 0 ? '企业' : '个人'}</Typography>
                        </div>) : <>
                        <Alert
                            className={classes.user}
                            severity="warning"
                            action={
                                <Button color="inherit"
                                        size="small"
                                        onClick={() => {
                                            setOpenAuthDialog(true)
                                        }}
                                >去实名</Button>
                            }
                        >完成实名认证</Alert>
                        <AuthenticationDialog
                            openAuthDialog={openAuthDialog}
                            setOpenAuthDialog={setOpenAuthDialog}
                            authTargetUser={user}
                            callback={reloadProfile}
                            title={"实名认证"}
                            authFunction={api.certification}
                        /></>
                ) : null
            }

            {notice ? (
                <Alert className={classes.user} severity="info">{notice}</Alert>
            ) : null}
        </div>
    );
};

Profile.propTypes = {
    className: PropTypes.string
};

export default Profile;
